module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ruth Dudley Edwards\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Ruth Dudley Edwards is a historian and journalist as well as a mystery writer. The targets of her satirical crime novels include the gentlemen's clubs, Cambridge University, the House of Lords, journalism and literary prizes. The British Crime Writers' Association short-listed Corridors of Death for the John Creasy Award for best first novel, and Clubbed to Death and Ten Lords A-Leaping for their Last Laugh Award. She won the CrimeFest Last Laugh Award for Murdering Americans in 2008 and in 2010 the CWA Non-fiction Gold Dagger for Aftermath: the Omagh bombings and the families' pursuit of justice. Her twelfth mystery, Killing the Emperors, is a black comedy about conceptual art.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1A7lyx9/tc-custom/9781615950669.jpg?1718183632989",
      "alt": "This image is the cover for the book Ten Lords A-Leaping, Robert Amiss/Baroness Jack Troutbeck Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ten Lords A-Leaping, Robert Amiss/Baroness Jack Troutbeck Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The House of Lords will never be the same again. Disinclined to watch her language or moderate her manners, Jack Troutbeck, assisted by her old friend Robert Amiss, plots vigorously with others to scupper an anti-hunting bill of which she violently disapproves. But she hadn't reckoned with the campaign of intimidation mounted by the animal activists and the attempt on the life of one of her allies, shortly followed by scenes of horrifying carnage amongst the peers...")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0